// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] + "-" + {"218":"4a6f3d4b96e740f4e723","532":"6b7673ffb9a3a9a02926","691":"b1aa5ef4889f1b858a27","774":"c7a69e8c04e8bb023650"}[chunkId] + ".js";
};